/** @jsxImportSource @emotion/react */
"use client";
import type { HallowElementProps } from "../../../types/hallowElementProps.types";
import { Text } from "../../_base/_core/Text/Text.emotion";

type AuthErrorProps = HallowElementProps<"p">;

export const AuthError = ({ children, ...props }: AuthErrorProps) => (
  <Text as={"p"} type={"detail"} size={"xl"} {...props}>
    {children}
  </Text>
);
